// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__27tT7","amount":"Amount_amount__-q5_v","tip":"Amount_tip__1w4jD","tipHeader":"Amount_tipHeader__1-L1U","tipsWrap":"Amount_tipsWrap__3DsVZ"};